import getApiClient from './../../../../plugins/api'

export default {
    send: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.error = ''

        if (! self.username) {
            self.error = 'Informe seu email'
            return
        }

        let postData = {
            username: self.username
        }

        if (self.$route.name === 'FirstAccess') {
            postData.firstAccess = true
        }

        self.$store.commit('startLoading')
        api.post('/reset_password', postData)
            .then(() => {
                self.message = 'Um link foi enviado para o seu email'
            })
            .catch(() => {
                self.error = 'Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.'
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })

    }
}
